import { useSelector } from '@legendapp/state/react';
import { sync$ } from '@/stores/sync$';
import { Cloud, CloudOff, Loader2, AlertCircle, Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export default function SyncStatus() {
  const isOnline = useSelector(() => sync$.isOnline.get());
  const isSyncing = useSelector(() => sync$.isSyncing.get());
  const pendingCount = useSelector(() => sync$.pendingCount.get());

  // Determine sync status
  const syncStatus = !isOnline ? 'offline' : isSyncing ? 'syncing' : pendingCount > 0 ? 'pending' : 'synced';
  const syncQueue = pendingCount;

  const getStatusConfig = () => {
    switch (syncStatus) {
      case 'synced':
        return {
          icon: Check,
          color: 'text-green-500',
          bgColor: 'bg-green-500/10',
          label: 'Synced',
        };
      case 'syncing':
        return {
          icon: Loader2,
          color: 'text-yellow-500',
          bgColor: 'bg-yellow-500/10',
          label: 'Syncing...',
          animate: true,
        };
      case 'error':
        return {
          icon: AlertCircle,
          color: 'text-red-500',
          bgColor: 'bg-red-500/10',
          label: `${syncQueue} pending`,
        };
      case 'offline':
        return {
          icon: CloudOff,
          color: 'text-muted-foreground',
          bgColor: 'bg-muted',
          label: 'Offline',
        };
      default:
        return {
          icon: Cloud,
          color: 'text-muted-foreground',
          bgColor: 'bg-muted',
          label: 'Idle',
        };
    }
  };

  const config = getStatusConfig();
  const Icon = config.icon;

  return (
    <div className="flex items-center gap-1.5 px-2 py-1.5 rounded-md hover:bg-muted/60 transition-colors cursor-default">
      <Icon
        size={14}
        className={cn(
          config.color,
          config.animate && 'animate-spin'
        )}
      />
      <span className="text-xs font-medium text-muted-foreground">
        {config.label}
      </span>
    </div>
  );
}
